import React from 'react'
import UserAccount from '../../components/userAccount/UserAccount'
import UserRoles from '../userRoles/UserRoles'
import "./userAccountPage.scss"

const UserAccountPage = ({ component }) => {
    let ComponentToRender;
    switch (component) {
        case "userAccount":
            ComponentToRender = <UserAccount />;
            break;
        case "userRoles":
            ComponentToRender = <UserRoles />;
            break;
        default:
            ComponentToRender = <UserAccount />;
            break;
    }

    return (
        <div className='userAccountPageContainer'>

            {component !== "userRoles" && <div className="">
                {/* <Sidebar /> */}
            </div>

            }
            <div className="userAccountPageTables">
                {ComponentToRender}

            </div>
        </div>
    )
}

export default UserAccountPage